import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ReactLenis } from 'lenis/react';

import Homepage from './pages/Homepage/Homepage';
import Socialspage from './pages/Socialspage/Socialspage';
import Consultancypage from './pages/Consultancypage/Consultancypage';
import Navbar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';
import NavigateToTop from './components/NavigateToTop/NavigateToTop';

const App = () => {
  return (
    <ReactLenis root options={{ lerp: 0.28, duration: 1.5, smoothWheel: true }}>
      <BrowserRouter>
        {/* Navbar can now safely use <NavLink> because it is inside BrowserRouter */}
        <NavigateToTop />
        <Navbar />
        
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/socials" element={<Socialspage />} />
          <Route path="/consultancy" element={<Consultancypage />} />
        </Routes>

        {/* Footer is placed here to keep it visible across all routes */}
        <Footer />
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;